import {OSkinableInit} from "back/commons/basis";
import {AppFrameDeskFeat, IApp, IAppBuilder, IAppCtx, JAppDef} from "back/core/appFrame";
import {SimpleTagArea} from "lib/commons/areas";
import {IReg, IRegPointer, REG} from 'lib/commons/registry';
import {JSX} from "lib/commons/xml/dom";
import {IBasicUniversePointer, IUniverseEnv} from "lib/core/universe";
import {Action, ActionHackCtx, IAction} from "lib/commons/actions";
import {JobsApp} from "back/core/apps/jobsApp";
import "back/core/plugins/plugins_Perms";

/**
 * Affichage du gestionnaire global des jobs des différents univers référencés
 *
 * @param contexte reg :
 * 	- liste des univers à traiter : "plg:jobs:universes"
 */
export function initApp(reg: IReg<IUniverseEnv> = REG.reg) {
	class WrapReg extends ActionHackCtx<Element, IReg<IUniverseEnv>> {
		constructor(sub: IAction<IReg<IUniverseEnv>>, public reg: IReg<IUniverseEnv>) {
			super(sub);
		}

		wrapCtx(ctx: Element): IReg<IUniverseEnv> {return this.reg}

		initButtonNode(buttonNode: Element, ctx: Element) {
			//Affectation du bon registre dans le contexte graphique.
			(buttonNode as IRegPointer<IUniverseEnv>).reg = this.reg;
			this.sub.initButtonNode(buttonNode, this.reg);
		}
	}

	function wrap(action: IAction<IReg<IUniverseEnv>>): IAction<Element> {
		return new WrapReg(action, reg);
	}

	const d = desk as AppFrameDeskFeat;
	d.addAppBuilder(new JobsAppBuilder(reg));

	//Menu Options > admin
	REG.reg.addToList("appframe:header:toolbar:params:admin", "jobs", 1, wrap(new Action().setLabel("Traitements")
		.requireVisiblePerm("ui.jobsPlg")
		.setExecute(function (this: Action, ctx, event) {
			(desk as AppFrameDeskFeat).findAndOpenApp({jobsUniverse: null} as JJobsAppDef);
		})
		.setIcon("/@skin@/core/apps/job.svg")
		.setVisible((ctx: IReg<IUniverseEnv>) => {
			return JobsApp.atLeastOneEntry(ctx.reg);
		})), 10);

}


/**
 * Schéma du hash de l'URL pour le JobsApp.
 * exemple : (jobsUniverse'')
 */
export interface JJobsAppDef extends JAppDef {
	/** Code de l'univers à afficher */
	jobsUniverse?: string[] | null
}

/** Construction async de l'app JobsApp. */
class JobsAppBuilder extends SimpleTagArea<IAppCtx<IBasicUniversePointer>, IApp<IBasicUniversePointer>> implements OSkinableInit, IAppBuilder<IBasicUniversePointer, IBasicUniversePointer> {

	skin?: string;

	skinOver?: string;

	constructor(public reg: IReg<any>) {
		super('jobs-app', reg.env.resolver.resolve(":back:core/apps/jobsApp.js"));
	}

	isAppDefMatch(data: JJobsAppDef):boolean {return "jobsUniverse" in data}

	newElt(ctx: IAppCtx<IBasicUniversePointer> & OSkinableInit): JobsApp {
		if (!ctx.skin) ctx.skin = this.skin;
		if (!ctx.skinOver) ctx.skinOver = this.skinOver;
		ctx.reg = this.reg;
		return (super.newElt(ctx) as JobsApp).initialize(ctx);
	}

}

